import React from 'react';
import logo from '../assets/logo.svg';
import '../styles/Loading.css';

export class Loading extends React.Component {

  render() {
    return (
      <div className="loading-div">
        <img src={logo} className="loading-logo" alt="logo" />
        <span className="loading-span">Loading</span>
        <img src={logo} className="loading-logo" alt="logo" />
      </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/Loading.js